import { Routes } from '@angular/router';
import { Home } from './page/home/home';

export const routes: Routes = [
    {
        path: '',
        component: Home
    },
    {
        path: '**', // Rotta di fallback per errori 404
        redirectTo: ''
    }
];